import { ImportedInvoiceReviewLineValues } from '@features/importedInvoices/types/importedInvoiceReviewFormSchema'

export const getDefaultImportedInvoiceReviewLine = (): ImportedInvoiceReviewLineValues => ({
  amountExclVat: null,
  categoryId: null,
  description: '',
  vatRateId: null,
})
